import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { UpdateVersionNotification } from 'entities/user.update_app/ui/notification';
import { isMobileApp, version_code } from 'utils';
export const UpdateVersionSuggestion = memo(function UpdateVersionNotifications() {
    const { new_version, current_version } = useAppSelector((state) => state.update_version);
    if (new_version == null || isMobileApp()) {
        return null;
    }
    if (version_code(new_version) <= version_code(current_version)) {
        return null;
    }
    return _jsx(UpdateVersionNotification, {});
});
